export default function (merchantData) {

    return {
        ...merchantData
    };
}


// WEBPACK FOOTER //
// ./src/Merchants/Model/merchantModelFactory.js